import { enter_tab } from "@/common/mixins/enter_tab";

export const form = {
  mixins: [enter_tab],
  data() {
    return {
      originData: null,
      isOpened: false,
    }
  },
  methods: {
    opened() {
      this.originData = JSON.stringify(this.data);
      this.isOpened = true;
    },
    hasChange() {
      if (!this.isOpened) { return false; }
      return this.originData !== JSON.stringify(this.data);
    },
    closeDialog() {
      this.$parent.handleClose();
      this.isOpened = this.$parent.opened;
      this.$emit('completed');
    }
  },
}
